import React, { Fragment } from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import DetailsReservationListItem from './ListItems/DetailsReservationListItem';
import CBSelect from '../../shared/CBSelect';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getStyle, getUrlId } from '../../../utils/utils';

class VehicleDetailsReservationList extends React.Component {
  isSelected = (reservation, idx) => {
    const urlParts = window.location.pathname.split('/');
    const index = urlParts.indexOf('reservations') + 1;

    if (index && urlParts[index]) {
      return reservation.id == urlParts[index];
    }

    return idx == 0;
  };

  reservationSelected = e => {
    const { history, vehicle } = this.props;
    history.push(`/vehicle/${vehicle.id}/reservations/${e.target.value}`);
  };

  //Do not remove. For unknown reasons the view won't re-render without this.
  static getDerivedStateFromProps(nextProps, prevState) {}

  render() {
    const { vehicle, location, reservations } = this.props;
    return (
      <CBMediaQuery>
        {screenSize => (
          <div
            style={getStyle(
              screenSize,
              styles,
              screenSize !== 'small' ? 'listContainer' : 'container',
            )}
          >
            {screenSize !== 'small' && (
              <div>
                {reservations.map((reservation, idx) => (
                  <DetailsReservationListItem
                    key={reservation.id}
                    vehicle={vehicle}
                    reservation={reservation}
                    isSelected={this.isSelected(reservation, idx)}
                  />
                ))}
              </div>
            )}
            {screenSize === 'small' && (
              <Fragment>
                <div style={getStyle(screenSize, styles, 'selectContainer')}>
                  <CBSelect
                    value={getUrlId(location.pathname)}
                    onChange={this.reservationSelected}
                    >
                    {reservations.map(reservation => (
                      <option key={reservation.id} value={reservation.id}>
                        {`${moment(reservation.start).format('D.M.Y')} | ${
                          reservation.description || reservation.standard_notation || ''
                        }`}
                      </option>
                    ))}
                  </CBSelect>
                </div>
              </Fragment>
            )}
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    listContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      backgroundColor: 'rgba(0, 149, 218, 0.4)',
      width: '25%',
    },
    selectContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: 40,
      marginRight: 15,
      marginLeft: 15,
      marginTop: 40,
    },
  },
  small: {
    listContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      backgroundColor: 'rgba(0, 149, 218, 0.4)',
      width: '100%',
      overflow: 'auto',
    },
  },
};

export default withRouter(VehicleDetailsReservationList);
